import React, { useState } from "react";

const EducationSection = () => {
    const [activeTab, setActiveTab] = useState("Education");

    const educationData = [
        {
            title: "MD Radiology",
            institution: "Kasturba Medical College, Manipal",
            year: "Expected Completion: January 2025",
            description: "Advanced postgraduate training in diagnostic and interventional radiology, including CT, MRI, ultrasound, and emergency imaging.",
        },
        {
            title: "MBBS",
            institution: "Apollo Institute of Medical Sciences and Research",
            year: "2019",
            description: "Graduated with distinction, excelling in clinical knowledge and hands-on medical training across various specialties.",
        },
        {
            title: "Board of Intermediate (Bi.P.C)",
            institution: "Sri Chaitanya Junior College",
            year: "2014",
            description: "Specialized in biology and chemistry, establishing a solid foundation for medical studies.",
        },
        {
            title: "School (I.C.S.E)",
            institution: "Gitanjali School",
            year: "2012",
            description: "Foundation for academic excellence with a focus on discipline and critical thinking.",
        },
    ];

    const experienceData = [
        {
            title: "Radiology Resident",
            company: "Kasturba Medical College, Manipal",
            duration: "2021-Present",
            description: "Involved in interpreting CT and MRI scans for emergency cases like stroke and trauma, ultrasound-guided procedures, and assisting in interventional radiology procedures. Contributing to tumor board discussions and interdepartmental meets.",
        },
        {
            title: "Online Consultant",
            company: "Apollo Kavach",
            duration: "2021-2022",
            description: "Provided online consultation for mild-to-moderate COVID-19 cases, offering advice on symptoms, treatment options, and post-care management.",
        },
        {
            title: "Intern",
            company: "Apollo Institute of Medical Sciences and Research",
            duration: "2019-2020",
            description: "Completed a compulsory rotating internship, developing clinical acumen across various medical specialties including surgery, pediatrics, and internal medicine.",
        },
    ];

    const skillsData = [
        "<strong>Advanced Diagnostic Imaging:</strong> CT, MRI, and ultrasound interpretation for emergency, musculoskeletal, gastrointestinal, and cardiac imaging.",
        "<strong>Ultrasound-Guided Procedures:</strong> Proficient in performing biopsies, FNAC, pleural tapping, and pigtail catheter placements.",
        "<strong>Interventional Radiology:</strong> Assisted in CT-guided biopsies, RF ablation, angioplasties, embolizations, and TACE procedures.",
        "<strong>Emergency Radiology:</strong> Expertise in handling trauma and stroke cases using CT, MRI, and ultrasound.",
        // "<strong>Research:</strong> Published research in areas like breast tumor margins, rotavirus infections, and lifestyle factors in health.",
        "<strong>Software Proficiency:</strong> PACS, DICOM viewers, EMR Systems, MS Office (Excel, Word, PowerPoint), and statistical analysis tools.",
    ];

    const awardsData = [
        {
            title: "Presented a Paper at WALTCon International Conference",
            year: "2019",
        },
        {
            title: "Presented a Poster at CIRCON National Conference",
            year: "2018",
        },
        {
            title: "Presented a Paper at BISICON National Conference",
            year: "2017",
        },
        {
            title: "Distinctions in Biochemistry, Pathology, Microbiology, Forensic Medicine, Ophthalmology, and SPM",
            year: "2016",
        },
        {
            title: "Silver Medal in Community Medicine and Microbiology",
            year: "2016",
        },
        {
            title: "3rd Prize for Poster Presentation on Rotavirus Prevalence",
            year: "2016",
        },
        {
            title: "Gold and Silver Medals in Singing",
            year: "2014, 2016",
        },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case "Education":
                return (
                    <div className="education-container">
                        {educationData.map((item, index) => (
                            <div key={index} className="item-container">
                                <h3>{item.title}</h3>
                                <p>{item.institution}, {item.year}</p>
                                <p className="description">{item.description}</p>
                            </div>
                        ))}
                    </div>
                );
            case "Experience":
                return (
                    <div className="experience-container">
                        {experienceData.map((item, index) => (
                            <div key={index} className="item-container">
                                <h3>{item.title}</h3>
                                <p>{item.company}, {item.duration}</p>
                                <p className="description">{item.description}</p>
                            </div>
                        ))}
                    </div>
                );
            case "Skills":
                return (
                    <div className="skills-container">
                        <ul>
                            {skillsData.map((skill, index) => (
                                <li key={index} dangerouslySetInnerHTML={{ __html: skill }} />
                            ))}
                        </ul>
                    </div>
                );
            case "Awards":
                return (
                    <div className="awards-container">
                        {awardsData.map((award, index) => (
                            <div key={index} className="item-container">
                                <h4>{award.title}</h4>
                                {award.year && <p className="year">{award.year}</p>}
                            </div>
                        ))}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <section className="education-section">
            <h2>My Resume</h2>
            <div className="tabs">
                <button
                    className={`tab ${activeTab === "Education" ? "active" : ""}`}
                    onClick={() => setActiveTab("Education")}
                >
                    Education
                </button>
                <button
                    className={`tab ${activeTab === "Experience" ? "active" : ""}`}
                    onClick={() => setActiveTab("Experience")}
                >
                    Experience
                </button>
                <button
                    className={`tab ${activeTab === "Skills" ? "active" : ""}`}
                    onClick={() => setActiveTab("Skills")}
                >
                    Skills
                </button>
                <button
                    className={`tab ${activeTab === "Awards" ? "active" : ""}`}
                    onClick={() => setActiveTab("Awards")}
                >
                    Awards
                </button>
            </div>
            <div className="tab-content">{renderContent()}</div>
        </section>
    );
};

export default EducationSection;
